import { EventEmitter } from '@angular/core';
import { MatMenu } from '@angular/material';
var FcButtonComponent = /** @class */ (function () {
    function FcButtonComponent() {
        this.click = new EventEmitter();
    }
    return FcButtonComponent;
}());
export { FcButtonComponent };
